import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const emptyClassName = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingBottom: Spacing.LG,
});

export const mediaClassName = css({
  marginTop: Spacing['2XL'],
});

export const iconClassName = css({
  color: '#AAB4C1',
  height: 48,
  width: 48,
});

export const bodyClassName = css({
  marginTop: Spacing.LG,
});

export const descriptionClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
});

export const actionClassName = css({
  marginTop: Spacing.LG,
});

export const buttonClassName = css({
  border: `1px solid ${Colors.LightGray}`,
  color: Colors.Primary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  padding: `${Spacing.SM}px ${Spacing.MD}px`,
  '&:hover': {
    background: Colors.Gray,
  },
});
